import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { DiagnosticEdit } from "@/features/catalog";
import { diagnosticDefinitionRouteId } from "@/features/catalog/lib/diagnostic-definition-route";

export const Route = createFileRoute("/catalog/diagnostics/new")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canWrite("ActivityDefinition")) throw redirect({ to: "/catalog/procedures" });
  },
  component: NewDiagnostic,
});

function NewDiagnostic() {
  const navigate = useNavigate();
  return (
    <DiagnosticEdit
      canEdit
      onDone={(url) =>
        url
          ? navigate({
              to: "/catalog/diagnostics/$diagnosticId",
              params: { diagnosticId: diagnosticDefinitionRouteId(url) },
            })
          : navigate({ to: "/catalog/procedures" })
      }
      onCancel={() => navigate({ to: "/catalog/procedures" })}
    />
  );
}
